import { Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import { fadeIn, fadeInLeft } from '../../../Litho/Functions/GlobalAnimations';
import Lists from '../../../Litho/Components/Lists/Lists';
const listData = [
	{ icon: 'fas fa-check', content: 'IATA compliant handling and packaging' },
	{ icon: 'fas fa-check', content: 'Dangerous goods expertise (DG)' },
	{ icon: 'fas fa-check', content: 'Temperature-controlled solutions' },
	{ icon: 'fas fa-check', content: 'Proactive customs documentation' },
];

const ComplianceSection = () => {
	return (
		<section className='py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] bg-lightgray overflow-hidden'>
			<Container>
				<Row className='items-center'>
					<m.div
						className='md:mb-[50px] sm:mb-[30px] col-xl-4 col-lg-6 offset-xl-2 order-lg-2'
						{...{
							...fadeInLeft,
							transition: { delay: 0.5, ease: 'circOut', duration: 0.6 },
						}}
					>
						<div className='-mr-[30vw] md:mr-0'>
							<img
								src='assets/img/services/air-freight-6.png'
								className='rounded-[5px] overflow-hidden w-full'
								height='945'
								width='605.17'
								alt='compliance'
							/>
						</div>
					</m.div>
					<m.div
						className='pr-[5%] sm:pr-[15px] col-xl-5 col-lg-6 order-lg-1'
						{...fadeIn}
					>
						<h5 className='font-serif font-medium text-darkgray leading-[40px] mb-[40px]'>
							Safety, compliance, and specialized handling
						</h5>
						<p className='mb-[25px]'>
							Air freight demands precision. Our teams follow strict IATA
							standards and execute specialized processes to protect your cargo
							end-to-end.
						</p>
						<Lists
							theme='list-style-01'
							className=''
							data={listData}
							animation={fadeIn}
						/>
					</m.div>
				</Row>
			</Container>
		</section>
	);
};

export default ComplianceSection;
